import { useState } from 'react'
import cx from 'classnames'

import { InteractionButton } from '../../InteractionButton'
import { ReactComponent as ArrowOutIcon } from 'assets/icons/arrow-out__16.svg'
import { ReactComponent as LinkIcon } from 'assets/icons/link16.svg'
import Styles from './HyperlinkInteractionButton.module.scss'
import { IconButtonProps } from 'components/IconButton/Types'

interface Props extends Partial<IconButtonProps> {
  href: string
}

export const HyperlinkInteractionButton = ({ className, href, ...additonalProps }: Props) => {
  const [isHovered, setHover] = useState(false)
  return (
    <a href={href} target="_blank" rel="noopener noreferrer nofollow ugc">
      <InteractionButton
        {...additonalProps}
        className={cx(Styles.hyperlinkButton, className)}
        icon={isHovered ? ArrowOutIcon : LinkIcon}
        onHoverStart={() => setHover(true)}
        onHoverEnd={() => setHover(false)}
      />
    </a>
  )
}
